const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/docsign/api-factory');
const serviceFactory = require('../resources/docsign/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/digisign/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match((
      `${p}docsign.showUserBanner[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.showUserBanner(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.saveUserSeenBanner[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.saveUserSeenBanner(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getDocumentTypeList[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getDocumentTypeList(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getEligiblePfList[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getEligiblePfList(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getEligibleClientList[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getEligibleClientList(req.params.inputs.substring(1, req.params.inputs.length), req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getDocumentListForAdmin[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getDocumentListForAdmin(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.manageUserDocument[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) => 
        service.manageUserDocument(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.saveClientSub[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.saveClientSub(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getClientSub[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getClientSub(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getDocumentList[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getDocumentList(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getAcceptView[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getAcceptView(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      
      )))
    .match((
      `${p}docsign.getActionAccept[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) => 
        service.getActionAccept(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getDocuSignWebURL[{keys:inputs}][{keys:guidStr}]`
    ), requests => 
      Promise.all(requests.map(({ req, res }) => 
        service.getDocuSignWebURL(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.completeDocumentSign[{keys:inputs}][{keys:guidStr}]`
    ), requests => 
      Promise.all(requests.map(({ req, res }) =>
        service.completeDocumentSign(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getSignedDocument[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getSignedDocument(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.getRmTeamList[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getRmTeamList(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.searchRmName[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.searchRmName(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.searchClientName[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.searchClientName(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.searchOrderId[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.searchOrderId(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}docsign.searchDocumentName[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.searchDocumentName(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
}

module.exports = addRoutes;
